<script>
  import {
    createRecaptchaVerifier,
    getIdTokenResult,
    getMFAVerificationId,
    login,
    signInWithSMSCode,
  } from '../Api/api';
  import Button from './Common/Button.svelte';
  import ResetPassword from './ResetPassword.svelte';

  let inputMail = '';
  let inputPassword = '';
  let mfaVerificationId;
  let mfaResolver;
  let smsCode;
  let signInError;
  let forgotPassword = false;

  const onSignedIn = () => {
    return getIdTokenResult().then((token) => {
      if (!['admin', 'super-admin', 'singleChat'].includes(token.claims.level)) {
        signInError = 'Brukeren mangler tilgang til chat-admin';
      }
    });
  };

  const onSignInWithUsernameAndPassword = () => {
    signInError = undefined;
    if (inputMail && inputPassword) {
      login(inputMail, inputPassword)
        .then(onSignedIn)
        .catch(async (error) => {
          if (error.code === 'auth/multi-factor-auth-required') {
            const recaptchaVerifier = await createRecaptchaVerifier('recaptcha-container');
            return getMFAVerificationId(error.resolver, recaptchaVerifier).then(
              (verificationId) => {
                mfaVerificationId = verificationId;
                mfaResolver = error.resolver;
              },
            );
          } else {
            throw error;
          }
        })
        .catch((error) => {
          signInError = error.message;
        });
    }
  };

  const onSignInWithSMSCode = () => {
    if (smsCode) {
      signInWithSMSCode(mfaResolver, mfaVerificationId, smsCode)
        .then(() => {
          mfaVerificationId = undefined;
          mfaResolver = undefined;
          smsCode = undefined;
          return onSignedIn();
        })
        .catch((error) => {
          signInError = error.message;
        });
    }
  };

  const forgotPasswordSwitch = () => {
    forgotPassword = !forgotPassword;
  };
</script>

<div class="login-container">
  <div class="login">
    <img class="logo" src="/assets/tv2-logo.svg" alt="" />
    {#if forgotPassword}
      <ResetPassword />
    {:else}
      <div id="recaptcha-container" />
      {#if !mfaVerificationId}
        <input type="email" placeholder="E-post" bind:value={inputMail} />
        <input type="password" placeholder="Passord" bind:value={inputPassword} />
        <div class="btn-container">
          <Button on:click={onSignInWithUsernameAndPassword}>Logg inn</Button>
        </div>
        <hr />
        <div class="btn-container">
          <Button on:click={forgotPasswordSwitch}>Har du glemt passordet ditt?</Button>
        </div>
      {:else}
        <input type="text" placeholder="SMS-kode" bind:value={smsCode} />
        <div class="btn-container">
          <Button on:click={onSignInWithSMSCode}>Logg inn</Button>
        </div>
      {/if}
      {#if signInError}
        <p class="error">{signInError}</p>
      {/if}
    {/if}
  </div>
</div>

<style>
  .login-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 10%;
  }

  .login {
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 80px 50px 50px 50px;
  }

  .logo {
    width: 60px;
    height: 60px;
    margin-bottom: 80px;
  }

  .btn-container {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  input {
    font-size: 16px;
    border: none;
    outline: none;
    margin-bottom: 10px;
    border-radius: 4px;
    width: 300px;
    padding: 10px;
  }

  p.error {
    color: red;
    width: 300px;
    padding: 10px;
    text-align: center;
  }

  hr {
    width: 100%;
    color: white;
    margin: 40px 0 0 0;
  }

  @media (min-width: 640px) {
    .login {
      background-color: #0e0e19;
    }
  }
</style>
